import { render, staticRenderFns } from "./allsearch.vue?vue&type=template&id=e7897b58&"
import script from "./allsearch.vue?vue&type=script&lang=js&"
export * from "./allsearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports